








import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';

@Component
export default class VerticalTab extends BaseComponent {}
